import React, { FunctionComponent } from 'react';
import { Container } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

import CardStatusSection from 'components/CardStatusSection';
import { useDatePicker } from 'components/DatePicker/DatePicker.context';
import { GET_CARD_NETWORK_STATUS } from 'components/CardStatusSection/CardStatusSection.queries';

import CardEventsSection from './sections/CardEventsSection';
import GeneralEventsSection from './sections/GeneralEventsSection';

const styles = {
  container: {
    margin: '12rem auto 0 !important',
  },
};

type Props = {
  classes: ClassProp<typeof styles>;
};

const VenusStatusDetail: FunctionComponent<Props> = ({ classes }) => {
  const { startDate, endDate } = useDatePicker();

  return (
    <Container className={classes.container}>
      <CardStatusSection
        showActions
        query={GET_CARD_NETWORK_STATUS}
        params={{}}
      />

      <GeneralEventsSection startDate={startDate} endDate={endDate} />
      <CardEventsSection
        startDate={startDate}
        endDate={endDate}
        marketplace={'DOSH'}
      />
    </Container>
  );
};

export default withStyles(styles)(VenusStatusDetail);
